<template>
    <div id="tab6" class="img-show">
        <div class="white-bg">
            <div class="page-width main-content">
                <!-- 产品介绍 -->
                <div>
                    <div class="sub-title">
                        <p>综合信息显示系统</p>
                    </div>
                    <div class="intro">
                        综合信息显示系统提供环境管理、安防管理、应急管理、发布通知等功能。数据模式时显示区域人员进出情况，房间环境监测、监控及逃生路线、洁净等级等信息。通知模式时显示站点最新通知。综合信息显示系统具有实时数据可视化、多系统融合对接、多站点灵活配置、操作简单等特点。
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/info/房间环境监测.png"
                        alt=""
                        class="app-img"
                    />
                </div>
                <div class="sub-title">
                    <p>系统功能</p>
                </div>
            </div>
        </div>
        <div class="grey-bg">
            <div class="page-width main-content">
                <!-- 系统功能 -->
                <div class="system-function ksh-function energy-function">
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">站点管理</p>
                            <p class="p2">
                                建立多个站点，一个站点可部署在一个或多个电子显示屏上，用于综合信息显示，支持数据模式和通知模式设置。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/info/站点管理.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <img
                            src="../../../../../assets/img/softProduct/info/信息编辑.png"
                            alt=""
                            class="app-img"
                        />
                        <div class="card-text">
                            <p class="p1">信息发布</p>
                            <p class="p2">
                                支持发布各种通知，可同时关联多个站点，实现自动推送通知。
                            </p>
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">数据模式</p>
                            <p class="p2">
                                站点显示方式为数据模式时显示最新数据。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/info/监控及逃生路线.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <img
                            src="../../../../../assets/img/softProduct/info/通知.png"
                            alt=""
                            class="app-img"
                        />
                        <div class="card-text">
                            <p class="p1">通知模式</p>
                            <p class="p2">
                                站点显示方式为通知模式时显示最新通知。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="img-bottom"></div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
@import './softProduct.less';
</style>
